import { Tabs } from "@pankod/refine-antd";
import { CatalogList } from "./catalog/list";
import { SubCatalogList } from "./subcatalog/list";
import { SuperCategoryList } from "./supercategory/list";
import { AkgPriceRangeList } from "./akg-price-range/list";
import { useResource } from "@pankod/refine-core";

export const CatalogManagementList: React.FC = () => {
  const { resource: catalogResource } = useResource({
    resourceNameOrRouteName: "catalog",
  });
  const { resource: subCatalogResource } = useResource({
    resourceNameOrRouteName: "subcatalog",
  });
  const { resource: superCategoryResource } = useResource({
    resourceNameOrRouteName: "super-category",
  });
  return (
    <>
      <Tabs defaultActiveKey="1">
        <Tabs.TabPane tab="Katalog" key={1}>
          <CatalogList name={catalogResource.name}></CatalogList>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Alt Katalog (1. seviye)" key={2}>
          <SubCatalogList name={subCatalogResource.name}></SubCatalogList>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Süper Kategori (2. seviye)" key={3}>
          <SuperCategoryList name={superCategoryResource.name}></SuperCategoryList>
        </Tabs.TabPane>
        <Tabs.TabPane tab="AKG Fiyat Aralıkları" key={4}>
          <AkgPriceRangeList name="akg-price-ranges" />
        </Tabs.TabPane>
      </Tabs>
    </>
  );
};
